import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-one-col-area-button-h1',
  templateUrl: './one-col-area-button-h1.component.html',
  styleUrls: ['./one-col-area-button-h1.component.css']
})
export class OneColAreaButtonH1Component implements OnInit {

  @Input() oneColAreaButtonH1_params: any = {}
  constructor() { }

  ngOnInit(): void {
  }

}
